var A = /* @__PURE__ */ ((t) => (t.Duo = "DUO", t.SoloAI = "SOLO_AI", t.Playlist = "PLAYLIST", t.Tuto = "TUTO", t.Test = "TEST", t.Workshop = "WORKSHOP", t.StandaloneAdaptiveTest = "STANDALONE_ADAPTIVE_TEST", t.Revision = "REVISION", t.Experimentation = "EXPERIMENTATION", t))(A || {});
export {
  A as WorkModeType
};
//# sourceMappingURL=Workmode.js.map
